import { ApiEndPointConfig, EnvironmentConfigShape } from '@iotv/iotv-v3-types'
import { groupDefinitions } from './Cognito/groupDefinitions'
import { userInvitationConfig } from './Cognito/userInvites'
import { lambdaOverrides } from './Lambda/overrides'
import { rules } from './Ruleset'
import { uiBucketDef } from './S3'

const debug = process.env.REACT_APP_DEBUG === 'true' && false
export const parentHostedZoneName = 'iotv.link'

export const parentAcccountId = '252855055641'
export const parentAccountHostedZoneId = 'Z037408026LR1VED1RWZN'

const TLD = parentHostedZoneName
const mailFromSubDomain = 'mail'
const mailFromAccountName = 'info'

const {
  projectCode,
  AWS_DEFAULT_REGION,
  REACT_APP_PROJECT_CODE,
  REACT_APP_DEPLOYMENT_STAGE,
  stage = REACT_APP_DEPLOYMENT_STAGE,
  REACT_APP_AWS_DEFAULT_REGION,
} = process.env
const shortProjectCode = (projectCode ?? REACT_APP_PROJECT_CODE)?.substring(0, 4)
const getInternalAccountDomain = () => `${stage ?? REACT_APP_DEPLOYMENT_STAGE}.${shortProjectCode}.${TLD}`

/** used for example in s3 CORS configuration */
const getUIUrls = () => [
  //`https://app.${getInternalAccountDomain()}`,
  // `https://*.${getInternalAccountDomain()}`,
]

const apiConfigs: ApiEndPointConfig<'V020Api' | 'Fuck API'>[] = [
  {
    name: 'V020Api',
    endpoint: `https://control.${REACT_APP_DEPLOYMENT_STAGE}.v020.iotv.link`,
    region: AWS_DEFAULT_REGION ?? REACT_APP_AWS_DEFAULT_REGION ?? 'never',
  },
]

export const config: EnvironmentConfigShape = {
  google: {
    gcp: {
      clientId: '903446274831-lshl3denji3m3qpc3fg74r015mlapd5u.apps.googleusercontent.com',
      apiKey: 'AIzaSyCVQdK7-DIokXhFlNbpcwan0_RE4iX1Zos',
    },
  },
  ventureTypeExtensions: {
    Area: {
      subtype: ['Paddock', 'ExclusionZone', 'IrrigationArea'],
    },
  },

  weather: {
    openWeather: {
      apiKey: 'e489737747db3e59e835aeaee9cd1180',
    },
  },
  domain: stage === 'prod' ? 'watertogrow.com' : undefined,
  parentAccountDomain: undefined,
  internalAccountDomain: getInternalAccountDomain(),
  mailFromSubDomain,
  mailFromAccountName,
  uiUrls: getUIUrls(),
  apiConfigs: [
    {
      name: 'V020Api',
      endpoint: `https://control.${REACT_APP_DEPLOYMENT_STAGE}.v020.iotv.link`,
      region: AWS_DEFAULT_REGION ?? REACT_APP_AWS_DEFAULT_REGION ?? 'never',
    },
  ] as ApiEndPointConfig<'V020Api'>[],
  aws: {
    Cognito: { groupDefinitions, userInvitationConfig },
    Lamdba: lambdaOverrides,
    S3: { UIBuckets: uiBucketDef },
    // ECS: { Wideawake: { sizing: stage === 'prod' ? { cpu: 512, memoryLimitMiB: 2048} : { cpu: 256, memoryLimitMiB: 1024} } },
  },
  apps: {
    webUI: {
      ventureName: 'Water To Grow',
      initialRedirect: 'HOMEPAGE',
      useSpecializedViews: true,
      supportEmail: 'support@watertogrow.com',
    },
  },
  //   iotv: {
  //     "system-provisioning": {
  //         useDeprecatedCustomerHierachy: true, // for v020 this should be predicated on test | prod
  //     }
  // },
  BaseData: rules,
}

export type GeneratedNotificationContent = {
  title: string
  htmlContent: string
  textContent: string
}
export type NotificationGenerator = (incident: any) => Promise<GeneratedNotificationContent>
